<template>
  <div class="login">
    <div class="head">
      <img style="height:100px;" src="@/assets/img/home/login-title.png" @click="togo('home')" alt="">
    </div>
    <div class="container">
      <div style="text-align:center;font-size:20px;font-weight:bold">{{ type == "1" ? "企业登录" : "机构登录" }}</div>
      <el-form ref="loginForm" autocomplete="off" class="login-form" :model="loginForm" :rules="rules" label-position="left">
        <el-form-item prop="account">
          <el-input v-model="loginForm.account" name="account" type="text" autocomplete="on" placeholder="用户名"
            prefix-icon="el-icon-user" autofocus />
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="loginForm.password" name="password" type="password" autocomplete="off" placeholder="密码"
            prefix-icon="el-icon-lock" @keyup.enter.native="login" />
        </el-form-item>
        <el-form-item prop="validCode" style="position: relative">
          <el-input v-model="loginForm.validCode" name="validCode" autocomplete="off" placeholder="验证码"
            @keyup.enter.native="login" />
          <img class="valite-img" :src="src" alt="验证码" @click="changeImg" />
        </el-form-item>
        <div class="caihuabox" v-if="(type == '1')">
          <div class="fl" @click="resetModifyPwd">忘记密码？</div>
          <div class="fr" @click="registerFn">没有账号，立即注册</div>
        </div>
        <el-form-item>
          <div class="loginsubmit" @click="login">登录</div>
        </el-form-item>
      </el-form>
    </div>
    <div class="bottom">
      <a class="company" href="https://www.akbigdata.cn/#/home" target="_blank">安康大数据运营有限公司</a>
    </div>

    <!-- 重置密码 -->
    <el-dialog :title="modifyPwdDialog.title" :visible.sync="modifyPwdDialog.visible" :before-close="closeModifyPwdDialog"
      :close-on-click-modal="false" :close-on-press-escape="false" :destroy-on-close="true" width="530px"
      :append-to-body="true" top="10vh">
      <div>
        <el-form ref="modifyPwdForm" class="modifyPwd-form" autocomplete="off" :model="modifyPwdDialog" :rules="rules"
          label-width="80px">
          <el-form-item prop="oldPassword" label="原密码">
            <el-input v-model="modifyPwdDialog.oldPassword" type="password" placeholder="原密码" :autofocus="true" />
          </el-form-item>
          <el-form-item prop="newPassword" label="新密码">
            <el-input v-model="modifyPwdDialog.newPassword" type="password" placeholder="新密码" />
          </el-form-item>
          <el-form-item prop="confirmPassword" label="确认密码">
            <el-input v-model="modifyPwdDialog.confirmPassword" type="password" placeholder="确认密码" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeModifyPwdDialog">取 消</el-button>
        <el-button type="primary" @click="modifyPwd">确 定</el-button>
      </span>
    </el-dialog>


    <!-- 忘记密码 -->
    <el-dialog :title="resetDialog.title" :visible.sync="resetDialog.visible" :before-close="closeResetDialog"
      :close-on-click-modal="false" :close-on-press-escape="false" :destroy-on-close="true" width="700px"
      :append-to-body="true" top="22vh">
      <div class="resetDialogBox">

        <el-steps :active="resetDialog.step" style="margin: 0 0 40px 0;">
          <el-step title="密码重置" icon="el-icon-success"></el-step>
          <el-step title="重置完成" icon="el-icon-success"></el-step>
        </el-steps>

        <el-form v-if="(resetDialog.step == 1)" class="forget-form" :rules="forgetRules"  label-position="left" autocomplete="off" :model="resetDialog" label-suffix="：" label-width="110px" >
          <el-form-item label="手机号" prop="account">
              <el-input prefix-icon="el-icon-phone-outline" name="account" v-model="resetDialog.account" autocomplete="on" maxlength="11" placeholder="请输入手机号">
            </el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="validCode" style="position: relative">
            <el-input prefix-icon="el-icon-chat-dot-square" name="code" v-model="resetDialog.validCode" autocomplete="on" placeholder="请输入验证码" />
            <img class="valite-img2" :src="resetDialog.src" alt="验证码" @click="changeResetImg" />
          </el-form-item>
          <el-form-item label="短信验证码" prop="code">
            <el-input prefix-icon="el-icon-chat-dot-square" name="code" v-model="resetDialog.code" autocomplete="on" placeholder="请输入短信验证码">
              <template slot="append">
                <el-button @click="getResetCode()">{{ title }}</el-button>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="password" label="设置新密码">
            <el-input prefix-icon="el-icon-unlock" v-model="resetDialog.password" type="password" placeholder="请输入密码" :autofocus="true" />
          </el-form-item>
          <el-form-item prop="newPassword" label="确认密码">
            <el-input prefix-icon="el-icon-lock" v-model="resetDialog.newPassword" type="password" placeholder="请再次输入您登录的密码" :autofocus="true" />
          </el-form-item>
        </el-form>

        <div v-if="(resetDialog.step == 2)" style="width:100%">
          <p style="width:225px;height: 40px; margin:0 auto;">新登录密码设置成功，请重新登录！</p>
          <div style="width:98px;height: 40px; margin:0 auto;">
            <el-button type="primary" @click="closeResetDialog">重新登录</el-button>
          </div>
        </div> 

      </div>
      <div slot="footer" class="dialog-footer" v-if="(resetDialog.step != 2)">
        <el-button @click="closeResetDialog">取 消</el-button>
        <el-button type="primary" @click="reset">下一步</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { login, modifyPwd, generateUuid, smsVerCode , forgetPassword } from "./viewApi";
import { validateForm, validatePwd } from "@/utils";
import { rsaEncrypt } from "@/utils/jsencrypt";
import {  sendSmsVerCode, checkVerCode } from '@/api';

export default {
  data() {
    var validateConfirmPwd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入确认密码"));
      } else if (value !== this.modifyPwdDialog.newPassword) {
        callback(new Error("确认密码和新密码不一致。"));
      } else {
        callback();
      }
    };
    return {
      type: '',
      activeName: "first",
      timer: null,
      efficient: true,
      src: process.env.VUE_APP_BASE_API +  "/credit/accountLogin/0000/validCode?uid=" +Math.random(),
      loginLoading: false,
      loginForm: {
        account: "",
        password: "",
        validCode: "",
      },
      modifyPwdDialog: {
        title: "修改密码",
        visible: false,
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      resetDialog: {
        title: "忘记密码",
        visible: false,
        src: process.env.VUE_APP_BASE_API +  "/credit/accountLogin/0000/validCode?uid=" +Math.random(),
        account: '',
        validCode:'',
        code: '',
        password: '',
        newPassword: '',
        step: 1,
        second: '', //倒计时
        disabled: false, //是否禁用按钮
        timer: null, //计时器
      },
      rules: {
        account: [
          {
            required: true,
            message: "请输入用户名",
            trigger: ["blur", "change"],
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: ["blur", "change"],
          },
          { validator: validatePwd },
        ],
        validCode: [
          {
            required: true,
            message: "请输入验证码",
            trigger: ["blur", "change"],
          },
        ],
        oldPassword: [
          {
            required: true,
            message: "请输入原密码",
            trigger: ["blur", "change"],
          },
        ],
        newPassword: [
          {
            required: true,
            message: "请输入新密码",
            trigger: ["blur", "change"],
          },
          { validator: validatePwd },
        ],
        confirmPassword: [
          {
            required: true,
            message: "请输入确认密码",
            trigger: ["blur", "change"],
          },
          {
            validator: validateConfirmPwd,
            trigger: ["blur", "change"],
          },
        ],
      },

      forgetRules: {
        account: [
          {
            required: true,
            message: "请输入电话号码",
            trigger: ["blur", "change"],
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: ["blur", "change"],
          },
          { validator: validatePwd },
        ],
        newPassword: [
          {
            required: true,
            message: "请再次输入您登录的密码",
            trigger: ["blur", "change"],
          },
          { validator: validatePwd },
        ],
        validCode: [
          {
            required: true,
            message: "请输入验证码",
            trigger: ["blur", "change"],
          },
        ],
        code: [
          {
            required: true,
            message: "请输入短信验证码",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  computed: {
    title() {
      return this.resetDialog.disabled ? `重新获取 ( ${this.resetDialog.second} ) s` : '短信验证码';
    },
  },
  created() {
    if (this.$route.query && this.$route.query.type) {
      this.type = this.$route.query.type
    }
  },
  mounted() {
    this.changeImg();
  },
  beforeDestroy() { },
  methods: {
    togo(name) {
      this.$router.push({
        name: name,
      });
    },

    changeImg() {
      this.src = process.env.VUE_APP_BASE_API + "/credit/accountLogin/0000/validCode?uid=" + Math.random();
    },

    login() {
      if (!validateForm(this.$refs["loginForm"])) {
        message = "表单信息缺失。";
        this.$baseMessage(message, "error");
        return;
      }
      this.loginLoading = true;
      const params = JSON.parse(JSON.stringify(this.loginForm));
      params.password = rsaEncrypt(params.password);
      params.type = this.type;
      login(Object.assign(params, { uid: this.src.split("=")[1] }))
        .then((res) => {
          if ((res.data.type == 4) || (res.data.type == 5)) {
            clearTimeout(this.timer);
            if (res.data.firstLogin) {
              this.$store.dispatch("setToken", res.data.token);
              this.modifyPwdDialog.visible = true;
            } else {
              if (this.timer) {
                clearTimeout(this.timer);
              }
              this.$store.dispatch("setToken", res.data.token);
              this.$store.dispatch("deletePermissionList");
              this.$store.dispatch("setUserInfo", JSON.stringify(res.data));
              if ((this.type == 1) && (res.data.type == 4)) {
                this.$router.push("/workbench/work");
              } else if ( (this.type==2) && (res.data.type == 5) ) {
                this.$router.push("/financInstitutionPC/staging");
              }else{
                this.$store.dispatch("setToken", '');
                this.$store.dispatch("setUserInfo", '');

                window.localStorage.removeItem('tokenweb');
                window.localStorage.removeItem('userInfoweb');

                this.$baseMessage('该账号不存在！！！', "error");
              }
            }
            this.changeImg();
          } else {

            this.$store.dispatch("setToken", '');
            this.$store.dispatch("setUserInfo", '');

            window.localStorage.removeItem('tokenweb');
            window.localStorage.removeItem('userInfoweb');

            this.$baseMessage('该账号不存在！！！', "error");
          }
        })
        .catch(() => {
          this.changeImg();
          this.loginLoading = false;
        });
    },

    modifyPwd() {
      if (!validateForm(this.$refs["modifyPwdForm"])) {
        message = "表单信息缺失。";
        this.$baseMessage(message, "error");
        return;
      }
      const params = {
        oldPassword: rsaEncrypt(this.modifyPwdDialog.oldPassword),
        newPassword: rsaEncrypt(this.modifyPwdDialog.newPassword),
      };
      modifyPwd(params).then((res) => {
        this.$baseMessage("修改密码成功，请重新登录。", "success");
        this.changeImg();
        this.closeModifyPwdDialog(true);
      });
    },

    closeModifyPwdDialog() {
      this.modifyPwdDialog.visible = false;
      this.modifyPwdDialog.newPassword = "";
      this.modifyPwdDialog.confirmPassword = "";
    },

    registerFn() {
      this.$router.push("/register");
    },

    resetModifyPwd() {
      this.resetDialog.visible = true;
    },

    reset() {
      if (this.resetDialog.step == 1) { //密码重置
        this.resetDialog.uid = this.resetDialog.src.split("=")[1];
        console.log(888, this.resetDialog.password , this.resetDialog.newPassword )
        forgetPassword({
          uid: this.resetDialog.uid,
          validCode: this.resetDialog.validCode,
          code: this.resetDialog.code,
          account: this.resetDialog.account,
          password: rsaEncrypt(this.resetDialog.password), 
          newPassword: rsaEncrypt(this.resetDialog.newPassword), 
        }).then((res)=>{
          this.resetDialog.step++;
        })
      } else if (this.resetDialog.step == 2) {//去登陆

      }
    },

    changeResetImg() {
      this.resetDialog.uid = Math.random();
      this.resetDialog.src = process.env.VUE_APP_BASE_API + "/credit/accountLogin/0000/validCode?uid=" + this.resetDialog.uid;
    },

    //获取短信验证码
    getResetCode() {
      if (!this.resetDialog.account) {
        this.$baseMessage("请先输入手机号", "error");
        return;
      }

      // debugger
      // checkVerCode({
      //   uid: this.registerForm.src.split("=")[1],
      //   code: this.registerForm.validCode,
      // }).then((res) => {
      //   if (res.code != 1000) {
      //     return
      //   }
      // });

      let s = 60  //倒计时间
      if (!this.resetDialog.timer) {
        this.resetDialog.second = s
        this.resetDialog.disabled = true
        this.resetDialog.timer = setInterval(() => {
          if (this.resetDialog.second > 0 && this.resetDialog.second <= s) {
            this.resetDialog.second--
          } else {
            this.resetDialog.disabled = false
            clearInterval(this.resetDialog.timer);
            this.resetDialog.timer = null
          }
        }, 1000)
      }
      // 调用后端发送短信验证码
      smsVerCode({ 
        phone: this.resetDialog.account,
      }).then(res => {
        if (res.code != 1000) {
          this.$message({ type: "error", message: res.message });
        }
      });
    },
    closeResetDialog() {
      this.resetDialog.visible = false;
      this.resetDialog.uid = '';
      this.resetDialog.account = '';
      this.resetDialog.src = '';
      this.resetDialog.validCode = '';
      this.resetDialog.validCode = '';
      this.resetDialog.code = '';
      this.resetDialog.password = '';
      this.resetDialog.newPassword = '';
      this.resetDialog.step = 1;
      this.resetDialog.second = '';
      this.resetDialog.disabled = false;
      this.resetDialog.timer = null;
    }

  },
};
</script>
<style scoped>
/deep/ .el-tabs__item.is-active {
  color: #ffffff !important;
}

/deep/ .el-tabs__active-bar {
  background-color: orange;
}

.qrcodeDom {
  margin: 0 auto;
  background-color: #ffffff;
  width: 400px;
  height: 400px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.dialog-footer {
  width: 170px !important;
  height: 50px !important;
  margin: auto !important;
}

.login .container .login-form .el-form-item:nth-child(3) {
  margin-bottom: 10px;
}

.caihuabox {
  width: 100%;
  margin: 20px auto;
  overflow: hidden;
  font-size: 13px;
}

.fl {
  float: left;
}
</style>
<style rel="stylesheet/scss" lang="scss">
.login {
  position: fixed;
  height: 100%;
  width: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url("~@/assets/img/home/login-bg.png");

  .head {

    .head-title {
      font-size: 50px;
      padding: 45px 0 45px 80px;
      color: black;
    }
  }

  .login-bg {
    position: fixed;
    z-index: -5;
    width: 100%;
    height: 100%;
  }

  .el-tabs__header {
    margin-bottom: 10px;

    .el-tabs__item {
      font-size: 15px;
    }
  }

  .logoImg {
    height: 81px;
    position: absolute;
    color: #fff;
    font-size: 50px;
    left: 50%;
    top: 18%;
    transform: translate(-50%, -45%);
  }

  .container {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 450px;
    padding: 20px 30px 20px 30px;
    transform: translate(-50%, -45%);
    // border-radius: 20px;
    /*background: #fff;*/
    // background: #fde8e2;
    background: white;
    box-shadow: 1px 5px 10px 10px rgba(0, 0, 0, 0.1);

    .login-form {
      margin-top: 20px;

      .el-form-item {
        margin-bottom: 30px;

        .el-input {
          height: 30px;
        }

        .valite-img {
          position: absolute;
          right: 3px;
          top: 1px;
          height: 38px;
          cursor: pointer;
        }
      }

      .loginsubmit {
        width: 100%;
        line-height: 40px;
        cursor: pointer;
        text-align: center;
        font-size: 18px;
        color: #ffffff;
        border-radius: 5px;
        background-color: green;
      }
    }

    .register {
      .el-form-item {
        margin-bottom: 20px;

        &:last-child {
          margin-bottom: 5px;
        }
      }

      .tip {
        color: #e6a23c;
        font-size: 13px;
        margin-bottom: 10px;
      }
    }
  }
  

  .title {
    display: inline;
    padding-bottom: 5px;
    font-size: 20px;
    letter-spacing: 2px;
    font-weight: 700;
    color: rgb(53, 53, 53);
    margin: 0px auto 10px auto;
    border-bottom: 3px solid green;
  }

  .bottom {
    position: absolute;
    bottom: 0;
    height: 60px;
    line-height: 60px;
    width: 100%;
    text-align: center;

    .company {
      color: #eee;
      font-size: 14px;
      letter-spacing: 1px;
    }
  }

}

.resetDialogBox {
    position: relative;
    width: 650px;
    padding: 0px 30px 0px 30px;
    background: white;

    .forget-form {
      .el-form-item {
        margin-bottom: 20px;

        .el-input {
          height: 30px;
        }
      }

      .valite-img2 {
          position: absolute;
          right: 3px;
          top: 1px;
          height: 38px;
          cursor: pointer;
        }


    }

  }
</style>
